import { render, staticRenderFns } from "./SearchEngine.vue?vue&type=template&id=52657a27&scoped=true"
import script from "./SearchEngine.vue?vue&type=script&lang=js"
export * from "./SearchEngine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52657a27",
  null
  
)

export default component.exports